/**
 * Preview leve de CSV no browser (sem lib).
 * Suficiente para mapear colunas e mostrar 5 linhas — não substitui parser server-side.
 */

export type CsvPreview = {
  headers: string[];
  rows: string[][];
};

/** Split CSV respeitando aspas simples/duplas. */
export function splitCsvLine(line: string): string[] {
  const cells: string[] = [];
  let current = "";
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (ch === '"' || ch === "'") {
      if (inQuotes && line[i + 1] === ch) {
        current += ch;
        i++;
      } else {
        inQuotes = !inQuotes;
      }
      continue;
    }
    if (ch === "," && !inQuotes) {
      cells.push(current.trim());
      current = "";
      continue;
    }
    current += ch;
  }
  cells.push(current.trim());
  return cells;
}

export function parseCsvPreview(text: string, maxRows = 5): CsvPreview | null {
  const lines = text
    .replace(/^\uFEFF/, "")
    .split(/\r\n|\n|\r/)
    .filter((line) => line.trim() !== "");

  if (lines.length === 0) {
    return null;
  }

  const headers = splitCsvLine(lines[0]).map((h) => h.trim()).filter(Boolean);
  if (headers.length === 0) {
    return null;
  }

  const rows = lines
    .slice(1, 1 + maxRows)
    .map((line) => splitCsvLine(line));

  return { headers, rows };
}

export function guessColumnMap(headers: string[]): {
  email: string;
  name: string;
  phone: string;
} {
  const lower = headers.map((h) => ({ raw: h, key: h.toLowerCase() }));
  const email =
    lower.find((h) =>
      ["email", "e-mail", "e_mail", "mail", "correo"].includes(h.key)
    )?.raw || headers[0] || "";
  const name =
    lower.find((h) =>
      ["name", "nome", "nombre", "full_name", "fullname"].includes(h.key)
    )?.raw || "";
  const phone =
    lower.find((h) =>
      [
        "phone",
        "telefone",
        "tel",
        "celular",
        "mobile",
        "whatsapp",
        "fone",
      ].includes(h.key)
    )?.raw || "";

  return { email, name, phone };
}

export function downloadContactsCsvTemplate(filename = "modelo-contatos.csv"): void {
  const content =
    "email,name,phone\nexemplo@empresa.com.br,Maria Silva,5511988887777\noutro@empresa.com.br,João Souza,11977776666\n";
  const blob = new Blob([content], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
